import SummaryIcon from "./SummaryIcon";

function ViewOnlyTextbox({name, value, showSummaryDetails, labelClassName, label, inputClassName}) {
    const colMatch = (inputClassName || '').match(/col-sm-\d+/);
    const colClass = colMatch ? colMatch[0] : 'col-sm-6';
    const inputClasses = showSummaryDetails
        ? (inputClassName || 'form-control').replace(/col-sm-\d+/g, '').replace(/\s+/g, ' ').trim()
        : inputClassName;

    const input = (
         <input type="text"
            id={name}
            name={name}
            readOnly={true}
            value={value}
            title={value || undefined}
            style={{ cursor: "not-allowed"}}
           className={inputClasses}/>
    );

    return (
        <>
        {label ? <label htmlFor={name} className={labelClassName}>{label}</label> : null}
         {showSummaryDetails ? (
           <div className={`${colClass} px-0 form-input-with-icon`}>
             {input}
             <SummaryIcon onClickHandler={showSummaryDetails}/>
           </div>
         ) : input}
        </>
    );
}

export default ViewOnlyTextbox;
